<!--<div [class]="'text-carusel '+ mode">-->
<!--<div [class]="'text-carusel-wrapper '+ mode">-->
<!--<div [class]="'text-carusel-container ' + mode" #HotNewsContainer [style.left]="currentLeft">-->
<!--<div *ngFor="let textItem of textList"-->
<!--[@TextBox]="textItem.state"-->
<!--[style.left]="textItem.left + 'px'"-->
<!--[ngClass]="{'text-content': true}" (click)="onGoTo(textItem)">-->

<!--&lt;!&ndash;[@TextBox]="textItem.state"&ndash;&gt;-->
<!--<h3>{{textItem.content[getLangId(currLang$)].title}}</h3>-->
<!--{{textItem.content[getLangId(currLang$)].descr}}</div>-->
<!--</div>-->
<!--<div class="list-indicator-container">-->
<!--<div *ngFor="let textItem of textList"-->
<!--(click) = onChangeState(textItem)-->
<!--[ngClass]="{'list-indicator': true, 'active': textItem.state == 'current'}"></div>-->
<!--</div>-->
<!--</div>-->
<!--</div>-->

<div [class]="'text-carusel '">
    <div [class]="'text-carusel-wrapper'">
        <!--[style.left]="currentLeft" -->
        <div class="text-carusel-container" #TextContainer [style.left]="'-'+currentLeft+'00%'" >
            <div [ngClass]="{'text-content': true}" >
                <a href="" routerLink="/">ALARIS LABS</a> is a software developing
                company that provides a suite of products enabling voice wholesale and SMS hubbing
                business. <br>
                Voice carriers can benefit from <a href="" routerLink="/voice">ALARIS inVOICE</a> -
                a high-capacity billing and routing solution that facilitates partner management
                (interconnections, rates, billing, bilateral agreements, DID management, alerting,
                analytics) and ensures real-time routing with a manual or dynamic (LCR, quality-based
                etc.) approach on a number of softswitches and SBCs (Sonus, Sansay, Dialogic, Genband,
                Mera MVTS, Huawei, VOS, Freeswitch and others) over the SIP 300/302 API.
            </div>

            <div [ngClass]="{'text-content': true}" >
                <a href="" routerLink="/messaging">ALARIS MESSAGING TOOLKIT</a> is a set of
                products helping mobile carriers and aggregators efficiently run messaging business. SMS
                aggregation can be most efficiently organized with Alaris SMS Platform - an all-in-one
                system to handle one- or two-way A2P and P2P traffic via a multitude of protocols and
                OTT APIs: SMPP, CMPP, HTTP, SIGTRAN, UCP, ParlayX, RCS, WhatsApp, Viber, Telegram etc.
                Heavy-duty message switching (up to 25000 SMS/sec) is supplemented with a vast variety
                of business features: efficient carrier and rate management, real-time routing, event-
                and session-based billing, volume and swap deals, reporting and analysis).
            </div>

            <div [ngClass]="{'text-content': true}" >
                Enterprise messaging is powered by Alaris Campaign Portal - an
                omnichannel solution enabling B2C A2P messaging for retail brands. The highest degree of
                mobile network protection is achieved by means of Alaris SMS Firewall that filters all
                MNO traffic over SS7 and SMPP based on intelligent rules analyzing message content,
                Sender ID, source GT, traffic volume patterns in order to detect SIM boxes, grey routes
                and other types of fraud.
            </div>
        </div>

        <div class="list-indicator-container topmargin">
            <div *ngFor="let textItem of textList"
                 (click)=onChangeState(textItem)
                 [ngClass]="{'list-indicator': true, 'active': textItem.state == 'current'}"></div>
        </div>
    </div>
</div>
